import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import 'react';
import { JamImage, BoldHeading } from '@lendi-jam/atoms';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { handleButtonTrackingEvent, handleLinkTrackingEvent } from '@lendi-jam/tracking';
import { Button } from '@lendi-ui/button';
import Container from '@lendi-ui/container';
import Grid from '@lendi-ui/grid';
import { link, Body } from '@lendi-ui/typography';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { map, between } from '@lendi-ui/breakpoint';
import { bg, color } from '@lendi-ui/color';
import { py, my, p, ml } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsx, jsxs } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var TextImageContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  ", "\n"])), function (_ref) {
  var colourVariant = _ref.colourVariant;
  switch (colourVariant) {
    case 'grey':
      return bg('shade.50');
    case 'mint':
      return bg('primary.50');
    default:
      return;
  }
});
var imageHeight = function imageHeight() {
  return "\n  @media (min-width: 0) {\n    height: 300px;\n  }\n\n  @media (min-width: 36rem) {\n    height: 400px;\n  }\n\n  @media (min-width: 48rem) {\n    height: 600px;\n  }\n  ";
};
var maxWidthQuery = map({
  lg: '41.666%',
  xl: '50%'
}, function (value) {
  return "max-width: ".concat(value, ";");
});
var ImageUnit = styled(Grid.Unit)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0;\n  ", "\n\n  & > div {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"])), imageHeight(), between('xs', 'md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      left: 0;\n    "]))), imageHeight(), function (_ref2) {
  var variant = _ref2.variant;
  return variant !== 'left' ? "left: 0;" : null;
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant !== 'left' ? maxWidthQuery : null;
});
var ContentUnit = styled(Grid.Unit)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), py('xxxl'), my('md'));
var LayoutImage = styled(JamImage)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  picture {\n    img {\n      ", "\n    }\n  }\n"])), function (_ref4) {
  var variant = _ref4.variant;
  return map({
    xs: '100%',
    lg: variant === 'left' ? '50%' : '100%'
  }, function (value) {
    return "width: ".concat(value);
  });
});
var LayoutLink = styled.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  text-decoration: none;\n  display: inline-block;\n  vertical-align: sub;\n  line-height: 1;\n  ", "\n  ", "\n"])), link({
  size: 'xs'
}), color('primary.500'), p('xxs'), ml('sm'));

var TextImageLayout = function TextImageLayout(_ref) {
  var title = _ref.title,
    content = _ref.content,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    image = _ref.image,
    alt = _ref.alt,
    _ref$colourVariant = _ref.colourVariant,
    colourVariant = _ref$colourVariant === void 0 ? 'white' : _ref$colourVariant,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'left' : _ref$variant;
  return /*#__PURE__*/jsx(TextImageContainer, {
    colourVariant: colourVariant,
    children: /*#__PURE__*/jsx(Container, {
      children: /*#__PURE__*/jsxs(Grid, {
        reverse: variant !== 'left',
        children: [/*#__PURE__*/jsxs(ContentUnit, {
          size: {
            lg: 1 / 2,
            xl: 5 / 12
          },
          offset: {
            lg: variant !== 'left' ? 1 / 12 : 0
          },
          children: [title && /*#__PURE__*/jsx(BoldHeading, {
            mb: "lg",
            size: 'lg',
            children: title
          }), content && /*#__PURE__*/jsx(Body, {
            mb: "lg",
            children: content
          }), primaryButton && primaryButton.text && /*#__PURE__*/jsx(Button, {
            variant: "primary",
            size: "lg",
            href: embedMarketingTrackingIntoURL(primaryButton.url),
            onClick: function onClick() {
              handleButtonTrackingEvent(_objectSpread(_objectSpread({}, primaryButton), {}, {
                variant: 'primary'
              }));
            },
            children: primaryButton.text
          }), secondaryButton && secondaryButton.text && /*#__PURE__*/jsx(LayoutLink, {
            href: embedMarketingTrackingIntoURL(secondaryButton.url),
            onClick: function onClick() {
              handleLinkTrackingEvent(secondaryButton.url);
            },
            children: secondaryButton.text
          })]
        }), /*#__PURE__*/jsx(ImageUnit, {
          variant: variant,
          size: {
            lg: 5 / 12
          },
          offset: {
            lg: variant === 'left' ? 1 / 12 : 0
          },
          children: image && /*#__PURE__*/jsx(LayoutImage, {
            variant: variant,
            alt: alt,
            placeholder: image === null || image === void 0 ? void 0 : image.base64,
            src: image === null || image === void 0 ? void 0 : image.src,
            srcSet: image === null || image === void 0 ? void 0 : image.srcSet,
            sizes: image === null || image === void 0 ? void 0 : image.sizes
          })
        })]
      })
    })
  });
};

export { TextImageLayout as default };
